import { ProgressBar } from 'react-bootstrap'
import { FC } from 'react'
import { DashboardCardProps } from './types.d'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const UNLIMITED_THRESHOLD = 9999

const Pages: FC<DashboardCardProps> = ({ widgetData }) => {
    const unlimited = widgetData.maxAllowedPages >= UNLIMITED_THRESHOLD
    const progressBarPercentage = unlimited
        ? 0
        : Math.round(
              (100 * widgetData.count) / widgetData.maxAllowedPages
          )
    const limitLabel = unlimited
        ? '∞'
        : `${widgetData.count}/${widgetData.maxAllowedPages}`

    return (
        <div className="stat-card">
            <div
                className="stat-card__accent"
                style={{ background: 'linear-gradient(90deg, #06b6d4, #0891b2)' }}
            />
            <div className="stat-card__header">
                <div>
                    <div className="stat-card__label text-info">Pages</div>
                    <div className="stat-card__value text-info">
                        {limitLabel}
                    </div>
                </div>
                <div
                    className="stat-card__icon"
                    style={{ background: 'linear-gradient(135deg, #06b6d4, #0891b2)' }}
                >
                    <FontAwesomeIcon icon={['far', 'rectangle-list']} />
                </div>
            </div>
            {!unlimited && (
                <div className="stat-card__progress">
                    <ProgressBar
                        now={progressBarPercentage}
                        animated={progressBarPercentage < 100}
                        striped
                        variant="info"
                        label={`${widgetData.count} of ${widgetData.maxAllowedPages}`}
                        visuallyHidden
                        style={{ height: '6px', borderRadius: '3px' }}
                    />
                </div>
            )}
            <div className="stat-card__action">
                <Link
                    to={'/content/pages/new'}
                    className="btn btn-outline-info btn-block w-100 btn-sm"
                >
                    Add Page
                </Link>
            </div>
        </div>
    )
}

export default Pages
